<template>
	<div class="special-discount">
		<div class="title">LIMITED OFFER: GET 7 DAYS FREE!</div>
		<div class="timer">
			<div class="day">
				<div class="value">{{ day }}</div>
				<div class="time">DD</div>
			</div>
			<div class="line"></div>
			<div class="hour">
				<div class="value">{{ hour }}</div>
				<div class="time">HH</div>
			</div>
			<div class="mark">
				<img src="../../assets/images/risk.png" />
			</div>
			<div class="minute">
				<div class="value">{{ minute }}</div>
				<div class="time">MM</div>
			</div>
			<div class="mark">
				<img src="../../assets/images/risk.png" />
			</div>
			<div class="second">
				<div class="value">{{ second }}</div>
				<div class="time">SS</div>
			</div>
		</div>
	</div>
</template>

<script>
import moment from 'moment'

export default {
	name: 'specialDiscount',
	data() {
		return {
			day: '',
			hour: '',
			minute: '',
			second: ''
		}
	},
	mounted() {
		this.getTimeClock()
		setInterval(() => {
			this.getTimeClock()
		}, 1000)
	},
	methods: {
		getTimeClock() {
			let curr = moment()
			let tomTime = moment(moment().format('YYYY-MM-DD'))
				.add(2, 'days')
				.add('00:00:00', 'hour')
			let duration = moment.duration(tomTime.diff(curr))
			this.day = duration.days() < 10 ? '0' + duration.days() : duration.days()
			this.hour = duration.hours() < 10 ? '0' + duration.hours() : duration.hours()
			this.minute = duration.minutes() < 10 ? '0' + duration.minutes() : duration.minutes()
			this.second = duration.seconds() < 10 ? '0' + duration.seconds() : duration.seconds()
			//
		}
	}
}
</script>

<style lang="scss" scoped>
.special-discount {
	width: 100%;
	height: 150px;
	background-image: url('../../assets/images/discount-bg.png');
	background-size: cover;
	background-repeat: no-repeat;
	background-position: center;
	padding: 24px 0 23px 0;
	font-family: OpenSans;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	.title {
		// width: 309px;
		height: 24px;
		font-size: 18px;
		font-weight: bold;
		text-align: center;
		color: #ffffff;
	}
	.timer {
		width: 265px;
		height: 63px;
		border: solid 1px #5e6880;
		margin-top: 16px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 5px 14px;
		.line {
			width: 1px;
			height: 53px;
			background-color: #515c76;
			border-left: 1px solid #515c76;
		}
		.mark {
			margin-bottom: 10px;
			img {
				width: 6px;
				height: 18px;
				object-fit: contain;
			}
		}
		.value {
			width: 35px;
			height: 30px;
			font-size: 30px;
			font-weight: bold;
			line-height: 1;
			text-align: center;
			color: #ffffff;
		}
		.time {
			// width: 21px;
			height: 19px;
			opacity: 0.7;
			font-size: 14px;
			text-align: center;
			color: #ffffff;
		}
	}
}

@media screen and (max-width: 750px) {
	.special-discount {
		width: 100%;
		height: 150px;
	}
}
</style>

